import React, { Component } from "react";
import PropTypes from "prop-types";
import TLDRDownloadFileType from "./TLDRDownloadFileType";
import {
  analyticsTrackEvent,
  checkCeleryTaskStatus,
  getFeatureLimit,
  isFeatureAvailable,
  triggerDownload,
} from "../../../_utils/common";
import { connect } from "react-redux";
import TLDRDownloadJPEGFileQuality from "./TLDRDownloadJPEGFileQuality";
import TLDRDownloadImageScale from "./TLDRDownloadImageScale";
import axios from "axios";
import { EXPORT_DESIGN, EXPORT_VIDEO } from "../../../_actions/endpoints";
import TLDRDownloadArtBoardOptions from "./TLDRDownloadArtBoardOptions";
import { handleHTTPError } from "../../../_actions/errorHandlerActions";
import Format from "string-format";
import TLDRDownloadPNGTransparentBackground from "./TLDRDownloadPNGTransparentBackground";
import { StoryTypes } from "../../../_utils/constants";
import { ADVANCED_DOWNLOAD_QUEUE_PANEL, FeatureCodes } from "../constants";
import connectedFeatureAvailabilityWrapper from "../../common/withFeatureAvailability";
import { Box, Button } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import Alert from "../../social/Alert/Alert";
import { showToast } from "../../../_utils/showToast";
import TLDRDownloadGIFSpeed from "./TLDRDownloadGIFSpeed";
import { openAdvancedSettings } from "apps/simplified-web/src/_actions/sidebarSliderActions";

class TLDRDownloadOptions extends Component {
  constructor(props) {
    super(props);
    this.initState = {
      fileType:
        props.story?.payload?.story_type === StoryTypes.ANIMATED
          ? "mp4"
          : "png",
      isDownloading: false,
      imageQuality: 100,
      imageSize: 1,
      transparentBackground: false,
      downloadingArtBoardIndex: 0,
      selectedArtBoards: [],
      showUpgradeSubscriptionModal: false,
      gifSpeed: 1,
    };
    this.state = this.initState;
  }

  render() {
    let { fileType, selectedArtBoards, imageQuality, imageSize } = this.state;

    const {
      story,
      pageIds,
      inline,
      subscription,
      t,
      storyDuration,
      isStoryHeightAndWidthConsistent,
    } = this.props;
    const artboardsList = this.getArtBoardOptions();
    const isAnimatedStory = story?.payload?.story_type === StoryTypes.ANIMATED;

    const isArtboardDurationFeatureAvailable = isFeatureAvailable(
      subscription,
      FeatureCodes.VIDEO_DURATION
    );

    const durationLimit = isArtboardDurationFeatureAvailable
      ? getFeatureLimit(subscription, FeatureCodes.VIDEO_DURATION)
      : 0;

    if (selectedArtBoards) {
      if (selectedArtBoards.length === 0) {
        selectedArtBoards = [artboardsList[0]];
      } else if (selectedArtBoards[0].id !== "all") {
        selectedArtBoards = selectedArtBoards.filter((selectedArtboard) => {
          return pageIds.includes(selectedArtboard.id);
        });
        if (selectedArtBoards.length === 0) {
          selectedArtBoards = [artboardsList[0]];
        }
      }
    }

    const hasDurationExceeded =
      isArtboardDurationFeatureAvailable &&
      (durationLimit ?? 0) < (storyDuration ?? 0);

    return (
      <Box p={inline ? "0" : "0 1rem"}>
        {hasDurationExceeded && (
          <Alert status="error">
            {t("download_options.video_duration_exceeded", {
              durationLimit: durationLimit,
            })}
          </Alert>
        )}
        {(this.state.fileType === "mp4" || this.state.fileType === "gif") &&
          !isStoryHeightAndWidthConsistent && (
            <Alert status="error">
              {t("download_options.page_incosistent")}
            </Alert>
          )}
        <TLDRDownloadFileType
          fileType={fileType}
          onFileTypeChange={this.onFileTypeChange}
          isAnimatedStory={isAnimatedStory}
          supportedFileTypes={this.props.supportedFileTypes}
          hideHeader={this.props.hideFileTypeHeader}
        ></TLDRDownloadFileType>
        {fileType === "gif" && (
          <TLDRDownloadGIFSpeed
            gifSpeed={this.state.gifSpeed}
            onGIFSpeedChange={this.onGIFSpeedChange}
          ></TLDRDownloadGIFSpeed>
        )}

        {(fileType === "png" || fileType === "jpeg") &&
          !this.props.disableSizeChange && (
            <TLDRDownloadImageScale
              imageSize={imageSize}
              onImageSizeChange={this.onImageSizeChange}
              contentSize={story.contentSize}
            ></TLDRDownloadImageScale>
          )}
        {fileType === "png" && !this.props.disableTransparentChange && (
          <TLDRDownloadPNGTransparentBackground
            onTransparentBackgroundCheckBoxChange={
              this.onTransparentBackgroundCheckBoxChange
            }
          ></TLDRDownloadPNGTransparentBackground>
        )}

        {fileType === "jpeg" && (
          <TLDRDownloadJPEGFileQuality
            imageQuality={imageQuality}
            onImageQualityChange={this.onImageQualityChange}
          ></TLDRDownloadJPEGFileQuality>
        )}

        {["mp4", "gif"].indexOf(fileType) < 0 && (
          <TLDRDownloadArtBoardOptions
            selectedArtBoards={selectedArtBoards}
            artboardsList={artboardsList}
            onArtBoardsSelectionChange={this.onArtBoardsSelectionChange}
          ></TLDRDownloadArtBoardOptions>
        )}

        <Button
          variant="solid"
          disabled={
            !(selectedArtBoards?.length > 0) ||
            hasDurationExceeded ||
            ((this.state.fileType === "mp4" || this.state.fileType === "gif") &&
              !isStoryHeightAndWidthConsistent)
            || this.state.isDownloading
          }
          isFullWidth
          onClick={(e) => {
            this.props.checkFeatureAvailability(
              FeatureCodes.DOWNLOAD_AS_SVG,
              () => this.download(e),
              this.state.fileType
            );
          }}
          sx={{
            margin: "0.5rem 0 0.5rem 0",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
          isLoading={this.state.isDownloading}
        >
          {t("export_now_button")}
        </Button>
      </Box>
    );
  }

  componentDidMount() {
    const artboardsList = this.getArtBoardOptions();
    if (artboardsList.length) {
      this.props.onArtBoardsSelectionChange &&
        this.props.onArtBoardsSelectionChange([artboardsList[0]]);
    }
  }

  onImageSizeChange = (imageSize) => {
    this.setState({
      ...this.state,
      imageSize,
    });
  };

  onGIFSpeedChange = (gifSpeed) => {
    this.setState({
      ...this.state,
      gifSpeed,
    });
  };

  onFileTypeChange = (fileType) => {
    this.setState({
      ...this.state,
      fileType,
    });
  };

  onArtBoardsSelectionChange = (selectedArtBoards) => {
    this.setState({
      ...this.state,
      selectedArtBoards,
    });
    this.props.onArtBoardsSelectionChange &&
      this.props.onArtBoardsSelectionChange(selectedArtBoards);
  };

  onImageQualityChange = (quality) => {
    if (this.state.imageQuality === quality) {
      return;
    }

    this.setState({
      ...this.state,
      imageQuality: quality,
    });
  };

  onTransparentBackgroundCheckBoxChange = (checked) => {
    this.setState({
      ...this.state,
      transparentBackground: checked,
    });
  };

  download = (event) => {
    const { fileType } = this.state;

    this.setState(
      {
        ...this.state,
        isDownloading: true,
      },
      () => {
        this.props.onDownloading(true);
        if (fileType === "mp4") {
          this.startExportingVideo();
        } else if (fileType === "gif") {
          this.startExportingVideo();
        } else {
          this.downloadArtBoards();
        }
      }
    );
    analyticsTrackEvent("download", {
      design: fileType,
    });
  };

  showFailedMessage = () => {
    const { t } = this.props;
    this.onDownloadFinish();
    showToast({
      description: t("export_failed_message", { ns: "navbar" }),
      title: t("error", { ns: "common" }),
      status: "error",
    });
  };

  renderingTracker = (task_id) => {
    const { t } = this.props;
    checkCeleryTaskStatus(task_id, () => {})
      .then((result) => {
        if (result.response.status === "SUCCESS") {
          if (result.response.info.jobId) {
            showToast({
              description: t("export_finishing_touch_message", {
                ns: "navbar",
              }),
              title: t("export_waiting_message", { ns: "navbar" }),
              status: "info",
            });

            this.renderingTracker(result.response.info.jobId);
          } else {
            this.onDownloadFinish();

            if (this.props.onExportEnd) {
              this.props.onExportEnd(result.response.info);
            } else {
              const url =
                result.response.info?.zipped_file ||
                result.response.info?.urls?.[0] ||
                "";

              triggerDownload(url);
            }
          }
        } else {
          this.showFailedMessage();
        }
      })
      .catch((error) => {
        this.onDownloadFinish();
        this.showFailedMessage();
      });
  };

  startExportingVideo = () => {
    const { story, maxVideoHeight, t } = this.props;
    const { fileType, gifSpeed } = this.state;

    axios
      .post(Format(EXPORT_VIDEO, story.payload.id), {
        type: fileType ?? "video",
        gifSpeedx: gifSpeed,
        maxHeight: maxVideoHeight || -1,
      })
      .then((response) => {
        checkCeleryTaskStatus(response.data.id, () => {})
          .then((result) => {
            if (result.response.status === "SUCCESS") {
              showToast({
                description: t("render_wait_message", { ns: "navbar" }),
                title: t("render_message", { ns: "navbar" }),
                status: "info",
              });

              this.renderingTracker(result.response.info.jobId);
            } else {
              this.showFailedMessage();
            }
          })
          .catch((error) => {
            this.onDownloadFinish();
            this.props.handleHTTPError(error, this.props);
          });
      })
      .catch((error) => {
        this.onDownloadFinish();
        this.props.handleHTTPError(error, this.props);
      });
  };

  downloadArtBoards = async () => {
    // this.props.openAdvancedSettings(ADVANCED_DOWNLOAD_QUEUE_PANEL);

    const {
      imageQuality: quality = 100,
      imageSize: multiplier = 1,
      selectedArtBoards,
    } = this.state;

    const { story, t } = this.props;

    let imageQuality = quality / 100;
    let artboardIds = this.props.pageIds;

    if (selectedArtBoards?.length > 0 && selectedArtBoards[0].id !== "all") {
      artboardIds = selectedArtBoards.map((selectedArtBoard) => {
        return selectedArtBoard.id;
      });
    }

    axios
      .post(Format(EXPORT_DESIGN, story.payload.id), {
        format: this.state.fileType,
        quality: imageQuality,
        multiplier: multiplier,
        artboardIds: artboardIds,
        transparentBackground: this.state.transparentBackground,
      })
      .then((response) => {
        checkCeleryTaskStatus(response.data.id, () => {})
          .then((result) => {
            if (result.response.status === "SUCCESS") {
              showToast({
                description: t("exporting_now_message", { ns: "navbar" }),
                title: t("exporting_content", { ns: "navbar" }),
                status: "info",
              });

              this.renderingTracker(result.response.info.jobId);
            } else {
              this.showFailedMessage();
            }
          })
          .catch((error) => {
            this.showFailedMessage();
            this.onDownloadFinish();
            this.props.handleHTTPError(error, this.props);
          });
      })
      .catch((error) => {
        this.showFailedMessage();
        this.onDownloadFinish();
        this.props.handleHTTPError(error, this.props);
      });
  };

  onDownloadFinish = () => {
    this.setState({
      ...this.state,
      isDownloading: false,
      downloadingArtBoardIndex: 0,
    });
    this.props.onDownloading(false);
  };

  getArtBoardOptions = () => {
    const { pageIds, pagestore } = this.props;

    let artBoardList = [];
    artBoardList.push({
      label: "All Artboards",
      value: pageIds,
      id: "all",
    });

    pageIds.forEach((pageId, index) => {
      let title = pagestore.pages[pageId]?.title;
      artBoardList.push({
        label: title ?? `Artboard ${index + 1}`,
        value: pageId,
        id: pageId,
      });
    });

    return artBoardList;
  };
}

TLDRDownloadOptions.propTypes = {
  pageIds: PropTypes.arrayOf(PropTypes.string),
  storyDuration: PropTypes.number,
  isStoryHeightAndWidthConsistent: PropTypes.bool,
  story: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  auth: state.auth,
  subscription: state.subscription,
  pagestore: state.pagestore,
});

const mapDispatchToProps = (dispatch) => ({
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
});

export default withTranslation(["navbar", "billing"])(
  connectedFeatureAvailabilityWrapper(
    connect(mapStateToProps, mapDispatchToProps)(TLDRDownloadOptions)
  )
);
